function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.51 7.33l-3.86 8.21a1.35 1.35 0 01-1.22.75 1.33 1.33 0 01-1.21-.75L.35 7.33A4.45 4.45 0 010 5.43a5.43 5.43 0 0110.86 0 4.45 4.45 0 01-.35 1.9zM5.43 2.72a2.71 2.71 0 102.71 2.71 2.72 2.72 0 00-2.71-2.72z"
});

var SvgLocate = function SvgLocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 10.86 16.29"
  }, props), _ref);
};

export default SvgLocate;